/* unplugin-vue-components disabled */import { render } from "./feedback.vue?vue&type=template&id=e7ea6d96"
import script from "./feedback.vue?vue&type=script&lang=js"
export * from "./feedback.vue?vue&type=script&lang=js"

import "./feedback.vue?vue&type=style&index=0&id=e7ea6d96&lang=stylus"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/controls/feedback.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e7ea6d96"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e7ea6d96', __exports__)) {
    api.reload('e7ea6d96', __exports__)
  }
  
  module.hot.accept("./feedback.vue?vue&type=template&id=e7ea6d96", () => {
    api.rerender('e7ea6d96', render)
  })

}


export default __exports__